var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.593 39.326h-3.826v9.026c0 2.323-.936 4.17-3.682 4.17-2.72.028-3.502-1.873-3.502-4.288v-8.906h-3.835v9.898c0 2.856 1 6.94 6.257 6.97 2.9.028 4.32-1.405 4.996-2.68v2.176h3.592V39.326zm1.52 16.362h3.826v-9.026c0-2.295.936-4.14 3.655-4.17 2.692 0 3.475 1.873 3.475 4.325v8.87h3.826v-9.86c0-2.892-1-6.97-6.22-7.006-2.863-.028-4.294 1.396-4.996 2.68l.027-2.176h-3.592v16.362zm16.25 0h3.826V39.326h-3.826v16.362zm0-18.566h3.826v-3.49h-3.826v3.49zm7.832 18.566h3.826v-13.35h2.746l-1.134-3.012h-1.61v-5.693h-3.826v5.693h-2.656v3.012h2.656v13.35zm10.272 5.72h4.087L138 39.326h-4.087l-3.853 10.88-3.916-10.88h-4.087l6.05 15.738-2.638 6.345zM53.763 47.36l6.986-12.304 3.376 12.304-3.376 12.304-6.986-12.304zm-3.403 1.992l6.986 12.304-12.17-3.177-8.795-9.127h13.98zm6.986-16.298L50.36 45.36H36.38l8.795-9.127 12.17-3.177zm9.975 10.118l-4.267-16.17-15.907 4.334-2.36 4.224-4.78-.037-11.65 11.835 11.65 11.835 4.78-.037 2.36 4.224 15.907 4.334 4.267-16.17L64.9 47.36l2.422-4.187z",
    fill: "#222c37",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/Unity.63865186c7e4e0a2fc808441ccccb3b8.svg";
export { ForwardRef as ReactComponent };